import _ from 'lodash';
import trimAll from '@/utils/trimAll';
function isContactRuleGroupEmpty(ruleGroup) {
    return _.isEmpty(_.trim(ruleGroup.name)) || _.isEmpty(trimAll(ruleGroup.rules));
}
export default isContactRuleGroupEmpty;
